import React from 'react';
import clsx from 'clsx';
import MuiSkeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        '&.MuiSkeleton-rect': {
            borderRadius: 6,
        }
    }
}))

export const Skeleton = (props) => {
    const {
        animation = 'wave',
        variant = 'rect',
        margin,
        className,
        style,
        ...args
    } = props;

    const classes = useStyles();

    return <MuiSkeleton 
        animation={animation}
        variant={variant}
        className={clsx(classes.root, className)}
        style={{
            margin,
            ...style
        }}
        {...args}
    />
}